(function () {
  var promoStorageKey = "game-impact-promo-wheel-dismissed";
  var promoCodePrefix = "ELUS";
  var rewards = [5, 5, 10, 5, 15, 5, 10, 5, 5, 30, 5, 10];
  var weightedRewards = [5, 5, 5, 5, 5, 5, 5, 5, 5, 10, 10, 10, 10, 15, 15, 30];
  var sliceAngle = 360 / rewards.length;
  var labelRadius = 108;
  var wheelStartAngle = -15;

  function isEmailValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function getNextSundayDeadline() {
    var now = new Date();
    var nextSunday = new Date(now);
    var daysUntilNextSunday = ((7 - now.getDay()) % 7) || 7;
    nextSunday.setDate(now.getDate() + daysUntilNextSunday);
    nextSunday.setHours(23, 59, 59, 999);
    return nextSunday;
  }

  function getTimeLeft(targetDate) {
    var difference = targetDate.getTime() - Date.now();
    if (difference <= 0) {
      return { hours: "00", minutes: "00", seconds: "00" };
    }
    var hours = Math.floor(difference / (1000 * 60 * 60));
    var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((difference % (1000 * 60)) / 1000);
    return {
      hours: String(hours).padStart(2, "0"),
      minutes: String(minutes).padStart(2, "0"),
      seconds: String(seconds).padStart(2, "0")
    };
  }

  function initMenus() {
    document.querySelectorAll("[data-menu-toggle]").forEach(function (toggle) {
      var navId = toggle.getAttribute("aria-controls");
      var nav = navId ? document.getElementById(navId) : null;
      if (!nav) return;

      toggle.addEventListener("click", function () {
        var isOpen = toggle.classList.toggle("is-open");
        nav.classList.toggle("is-open", isOpen);
        toggle.setAttribute("aria-expanded", String(isOpen));
        toggle.setAttribute("aria-label", isOpen ? "Fermer le menu" : "Ouvrir le menu");
      });

      nav.querySelectorAll("[data-close-menu]").forEach(function (link) {
        link.addEventListener("click", function () {
          toggle.classList.remove("is-open");
          nav.classList.remove("is-open");
          toggle.setAttribute("aria-expanded", "false");
          toggle.setAttribute("aria-label", "Ouvrir le menu");
        });
      });
    });

    document.querySelectorAll("[data-nav-link][data-disabled='true']").forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault();
      });
    });
  }

  function initFaqs() {
    document.querySelectorAll("[data-faq-list]").forEach(function (list) {
      list.querySelectorAll(".faq-trigger").forEach(function (button) {
        button.addEventListener("click", function () {
          var item = button.closest(".faq-item");
          var panel = item ? item.querySelector(".faq-answer") : null;
          var icon = button.querySelector(".faq-symbol");
          var isOpen = item.classList.toggle("is-open");

          button.setAttribute("aria-expanded", String(isOpen));
          if (panel) panel.hidden = !isOpen;
          if (icon) {
            icon.classList.toggle("ri-add-line", !isOpen);
            icon.classList.toggle("ri-subtract-line", isOpen);
          }
        });
      });
    });
  }

  function initProductGalleries() {
    document.querySelectorAll("[data-product-gallery]").forEach(function (gallery) {
      var image = gallery.querySelector("[data-gallery-image]");
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-thumb]"));
      var current = 0;
      var THUMBS_VISIBLE = 4;
      var stripIndex = 0;

      var thumbsTrack = gallery.querySelector(".product-gallery__thumbs");
      var thumbPrevBtn = gallery.querySelector("[data-thumb-prev]");
      var thumbNextBtn = gallery.querySelector("[data-thumb-next]");

      function getThumbStep() {
        if (!thumbs[0]) return 138;
        return thumbs[0].offsetWidth + 8;
      }

      function getMaxStrip() {
        return Math.max(0, thumbs.length - THUMBS_VISIBLE);
      }

      function applyStrip() {
        var step = getThumbStep();
        if (thumbsTrack) {
          thumbsTrack.style.transform = "translateX(-" + (stripIndex * step) + "px)";
        }
      }

      function scrollThumbIntoView(index) {
        if (index < stripIndex) {
          stripIndex = index;
          applyStrip();
        } else if (index >= stripIndex + THUMBS_VISIBLE) {
          stripIndex = Math.min(index - THUMBS_VISIBLE + 1, getMaxStrip());
          applyStrip();
        }
      }

      function syncStripButtons() {
        if (thumbPrevBtn) thumbPrevBtn.disabled = current === 0;
        if (thumbNextBtn) thumbNextBtn.disabled = current === thumbs.length - 1;
      }

      function show(index) {
        if (!image || !thumbs.length) return;
        current = (index + thumbs.length) % thumbs.length;
        image.src = thumbs[current].dataset.imageSrc;
        image.alt = thumbs[current].dataset.imageAlt || "";
        thumbs.forEach(function (btn, i) {
          btn.classList.toggle("is-active", i === current);
        });
        scrollThumbIntoView(current);
        syncStripButtons();
      }

      // Main gallery arrows (overlay on the big image)
      gallery.querySelectorAll("[data-gallery-prev]").forEach(function (btn) {
        btn.addEventListener("click", function () { show(current - 1); });
      });
      gallery.querySelectorAll("[data-gallery-next]").forEach(function (btn) {
        btn.addEventListener("click", function () { show(current + 1); });
      });

      // Clicking a thumb directly
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener("click", function () { show(i); });
      });

      // Strip arrows → change photo + keep strip in sync
      if (thumbPrevBtn) {
        thumbPrevBtn.addEventListener("click", function () { show(current - 1); });
      }
      if (thumbNextBtn) {
        thumbNextBtn.addEventListener("click", function () { show(current + 1); });
      }

      window.addEventListener("resize", applyStrip);
      applyStrip();
      syncStripButtons();
    });
  }

  function initElusCarousel() {
    document.querySelectorAll("[data-elus-carousel]").forEach(function (carousel) {
      var cards = Array.prototype.slice.call(carousel.querySelectorAll("[data-carousel-card]"));
      var activeIndex = 0;

      function getCircularOffset(index) {
        var offset = index - activeIndex;
        if (offset > cards.length / 2) offset -= cards.length;
        if (offset < -cards.length / 2) offset += cards.length;
        return offset;
      }

      function render() {
        var isMobile = window.matchMedia("(max-width: 767px)").matches;
        var gap = isMobile ? 92 : 190;
        var rotate = isMobile ? 5 : 9;
        var maxVisible = isMobile ? 1 : 2;

        cards.forEach(function (card, index) {
          var offset = getCircularOffset(index);
          var abs = Math.abs(offset);
          var isVisible = abs <= maxVisible;
          card.style.transform = "translate(-50%, -50%) translateX(" + (offset * gap) + "px) rotate(" + (offset * rotate) + "deg) scale(" + (abs === 0 ? 1 : isMobile ? 0.92 : 0.88) + ")";
          card.style.opacity = isVisible ? (abs === 0 ? "1" : "0.68") : "0";
          card.style.zIndex = isVisible ? String(100 - abs) : "1";
          card.style.pointerEvents = abs === 0 ? "auto" : "none";
          card.classList.toggle("is-active", abs === 0);
        });
      }

      carousel.querySelectorAll("[data-carousel-prev]").forEach(function (button) {
        button.addEventListener("click", function () {
          activeIndex = (activeIndex - 1 + cards.length) % cards.length;
          render();
        });
      });
      carousel.querySelectorAll("[data-carousel-next]").forEach(function (button) {
        button.addEventListener("click", function () {
          activeIndex = (activeIndex + 1) % cards.length;
          render();
        });
      });
      window.addEventListener("resize", render);
      render();
    });
  }

  function initCountdowns() {
    document.querySelectorAll("[data-promo-countdown]").forEach(function (countdown) {
      var hours = countdown.querySelector("[data-hours]");
      var minutes = countdown.querySelector("[data-minutes]");
      var seconds = countdown.querySelector("[data-seconds]");
      var label = document.querySelector("[data-promo-deadline-label]");

      function update() {
        var deadline = getNextSundayDeadline();
        var timeLeft = getTimeLeft(deadline);
        if (hours) hours.textContent = timeLeft.hours;
        if (minutes) minutes.textContent = timeLeft.minutes;
        if (seconds) seconds.textContent = timeLeft.seconds;
        if (label) {
          label.textContent = new Intl.DateTimeFormat("fr-FR", {
            weekday: "long",
            day: "numeric",
            month: "long"
          }).format(deadline);
        }
      }

      update();
      window.setInterval(update, 1000);
    });

    document.querySelectorAll("[data-delivery-date]").forEach(function (node) {
      var delivery = new Date(Date.now() + 4 * 24 * 60 * 60 * 1000);
      node.textContent = new Intl.DateTimeFormat("fr-FR", {
        day: "numeric",
        month: "long"
      }).format(delivery);
    });
  }

  function initPromoWheel() {
    var popup = document.querySelector("[data-promo-wheel]");
    if (!popup || window.localStorage.getItem(promoStorageKey) === "true") return;

    var urgencyBar = document.querySelector(".urgency-bar");

    rewards = String(popup.dataset.promoRewards || "")
      .split(",")
      .map(function (value) { return Number(value.trim()); })
      .filter(function (value) { return !Number.isNaN(value) && value > 0; });
    if (!rewards.length) rewards = [5, 10, 15, 30];

    weightedRewards = String(popup.dataset.promoWeightedRewards || "")
      .split(",")
      .map(function (value) { return Number(value.trim()); })
      .filter(function (value) { return !Number.isNaN(value) && value > 0; });
    if (!weightedRewards.length) weightedRewards = rewards.slice();

    promoCodePrefix = popup.dataset.promoCodePrefix || promoCodePrefix;
    sliceAngle = 360 / rewards.length;

    var disc = popup.querySelector("[data-promo-wheel-disc]");
    var email = popup.querySelector("[data-promo-email]");
    var spin = popup.querySelector("[data-promo-spin]");
    var error = popup.querySelector("[data-promo-error]");
    var hint = popup.querySelector("[data-promo-hint]");
    var form = popup.querySelector("[data-promo-form]");
    var result = popup.querySelector("[data-promo-result]");
    var badge = popup.querySelector("[data-promo-badge]");
    var code = popup.querySelector("[data-promo-code]");
    var rotation = 0;
    var spinning = false;

    popup.querySelectorAll("[data-slice-index]").forEach(function (label) {
      var index = Number(label.dataset.sliceIndex);
      var angle = wheelStartAngle + index * sliceAngle + sliceAngle / 2;
      var radians = angle * Math.PI / 180;
      label.style.left = "calc(50% + " + (Math.sin(radians) * labelRadius) + "px)";
      label.style.top = "calc(50% + " + (-Math.cos(radians) * labelRadius) + "px)";
    });

    function close() {
      window.localStorage.setItem(promoStorageKey, "true");
      popup.hidden = true;
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      if (urgencyBar) urgencyBar.style.display = "";
    }

    function pickReward() {
      return weightedRewards[Math.floor(Math.random() * weightedRewards.length)];
    }

    function getRewardIndex(reward) {
      var indexes = rewards.map(function (value, index) {
        return value === reward ? index : -1;
      }).filter(function (index) { return index >= 0; });
      return indexes[Math.floor(Math.random() * indexes.length)] || 0;
    }

    function syncCanSpin() {
      if (!spin || !email) return;
      spin.disabled = spinning || !isEmailValid(email.value);
    }

    if (email) email.addEventListener("input", syncCanSpin);
    popup.querySelectorAll("[data-promo-close]").forEach(function (button) {
      button.addEventListener("click", close);
    });

    if (spin) {
      spin.addEventListener("click", function () {
        if (!email || !isEmailValid(email.value)) {
          if (error) error.hidden = false;
          if (hint) hint.hidden = true;
          return;
        }

        var reward = pickReward();
        var rewardIndex = getRewardIndex(reward);
        var targetAngle = 360 - rewardIndex * sliceAngle - sliceAngle / 2;
        var nextRotation = rotation + 360 * 6 + targetAngle - (rotation % 360);

        spinning = true;
        syncCanSpin();
        spin.textContent = "La roue tourne...";
        if (error) error.hidden = true;
        if (hint) hint.hidden = false;
        if (disc) {
          disc.classList.add("is--spinning");
          disc.style.transform = "rotate(" + nextRotation + "deg)";
        }
        rotation = nextRotation;

        window.setTimeout(function () {
          spinning = false;
          window.localStorage.setItem(promoStorageKey, "true");
          if (badge) badge.textContent = "-" + reward + "% aujourd'hui";
          if (code) code.textContent = promoCodePrefix + reward;
          if (form) form.hidden = true;
          if (result) result.hidden = false;
        }, 4600);
      });
    }

    window.setTimeout(function () {
      popup.hidden = false;
      document.body.style.overflow = "hidden";
      if (urgencyBar) urgencyBar.style.display = "none";
      syncCanSpin();
    }, Number(popup.dataset.promoDelay || 900));
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMenus();
    initFaqs();
    initProductGalleries();
    initElusCarousel();
    initCountdowns();
    initPromoWheel();
  });
})();
